
var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_ol_object_interface = function () {
    OCS.Viewer.Interfaces.OlObject = {
        ol_object: null,
        id: null,
        get_ol_object: function () {
            return this.ol_object;
        },
        set_ol_object: function (ol_object) {
            this.ol_object = ol_object;
        },
        set_ol_setting: function (setting_name, value) {
            if (this.ol_object) {
                this.ol_object.set(setting_name, value);
            }
        },
        get_ol_setting: function (setting_name) {
            if (this.ol_object) {
                return this.ol_object.get(setting_name);
            }
        },
        get_id: function () {
            if (!this.id) {
                this.id = this.class_type + "-" + this.class_name + "-" + OCS.Viewer.Functions.get_utilities().makeUUID();
            }
            return this.id;
        },
    };
};
OCS.Viewer.Functions.define_ol_object_interface();
